var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IQOSTable',{attrs:{"cols":[{
      title: _vm.$t('subscription.transactions.date'),
      key: 'created_at',
      date: true
    }, {
      title: _vm.$t('subscription.transactions.time'),
      key: 'created_at',
      time: true
    }, {
      title: _vm.$t('subscription.transactions.system'),
      key: 'mode',
      renderer: function (r) { return ("" + ((r.mode || '').toUpperCase())); }
    }, {
      title: _vm.$t('subscription.transactions.sum'),
      key: 'total',
      currency: 'code'
    }, {
      title: _vm.$t('subscription.transactions.commission'),
      unit: '%',
      key: 'comission'
    }],"rows":_vm.transactions}})}
var staticRenderFns = []

export { render, staticRenderFns }